var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2427_10240)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55837 3.30785C4.67556 3.19081 4.83442 3.12507 5.00004 3.12507C5.16567 3.12507 5.32452 3.19081 5.44171 3.30785L7.79921 5.66452C7.9164 5.78176 7.98222 5.94077 7.98218 6.10654C7.98214 6.27231 7.91625 6.43128 7.799 6.54848C7.68175 6.66567 7.52275 6.73148 7.35698 6.73145C7.1912 6.73141 7.03223 6.66552 6.91504 6.54827L5.00004 4.63327L3.08504 6.54827C2.96722 6.66217 2.80937 6.72524 2.6455 6.7239C2.48162 6.72255 2.32483 6.6569 2.2089 6.54107C2.09296 6.42524 2.02716 6.26852 2.02566 6.10464C2.02416 5.94077 2.08708 5.78286 2.20087 5.66493L4.55796 3.30743L4.55837 3.30785Z",
    fill: "#576265"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2427_10240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 -1 10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.517b5edcc80ce93481a94a1f6d1e49ab.svg";
export { ForwardRef as ReactComponent };